/** 营销中心-图文专题-内容管理 */

// 获取内容管理列表
export const CONTENT_LIST = '/cmsms-new/content/list';
// 新增内容
export const CONTENT_SAVE = '/cmsms-new/content/save';
// 删除内容
export const CONTENT_DELETE = '/cmsms-new/content/delete';
// 内容详情
export const CONTENT_DETAIL = '/cmsms-new/content/detail';
// 内容详情-绑定精准推送
export const CONTENT_CHANNEL_BIND = '/cmsms-new/content/invoke';
// 内容详情-关联标签
export const CONTENT_LABEL_RELATE = '/cmsms-new/content/addLabel';
// 标签列表
export const CONTENT_LABEL_LIST = '/cmsms-new/content/labelList';
// 新增/编辑标签
export const CONTENT_LABEL_SAVE = '/cmsms-new/content/saveLabel';
// 删除标签
export const CONTENT_LABEL_DELETE = '/cmsms-new/content/deleteLabel';
